import React from "react";
import { useParams } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

const TITLES = { terms: "Terms & Conditions", privacy: "Privacy Policy", refund: "Refund & Cancellation Policy" };

export default function Policy() {
  const { slug } = useParams();
  const { settings } = useSettings();
  const content = settings?.[slug] || "";
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <h1 className="font-serif text-3xl sm:text-4xl font-bold text-sapore-purple mb-6">{TITLES[slug] || "Policy"}</h1>
      <div className="prose prose-sm max-w-none text-sapore-inkSoft whitespace-pre-wrap leading-relaxed" data-testid="policy-content">
        {content || "Content coming soon."}
      </div>
    </div>
  );
}
